import { MainTracker } from "../../../PixelTrackers/MainTracker";
import { useCustomer } from "../../../customHooks/useCustomer";
import { CannabisEffectsFilter } from "./CannabisEffectsFilter";
import { CannabisGeneticFilter } from "./CannabisGeneticFilter";
import { CannabisProductTypeFilter } from "./CannabisProductTypeFilter";
import { FavouriteFilter } from "./FavouriteFilter";
import { MedicalEffectsFilter } from "./MedicalEffectsFilter";
import { MultiChoiceFilters } from "./MultiChoiceFilters";

type Props = {
    filterOptions: { value: string, isSelected: boolean, name: string, keyWordTitle: string }[];
    keyWord: string;
    toggleFilter: (category: string, value: string, isMultiSelect?: boolean) => void;
    isLastChild?: boolean;
}

export const FilterOptionsSubMenu: React.FC<Props> = ({ filterOptions, keyWord, toggleFilter, isLastChild }) => {
    const { customerState } = useCustomer();
    
    const handleChooseFilter = (item: { value: string, isSelected: boolean }, isMultiSelect?: boolean) => () => {
        const wasSelected = item.isSelected;
        toggleFilter(keyWord, item.value, isMultiSelect);
        
        // Track filter_selected event when a filter is selected (critical for tracking product discovery behavior)
        // Only track when selecting (not deselecting)
        if (!wasSelected) {
            const userId = customerState?.customerID || null;
            
            if (keyWord === "favourite") {
                MainTracker.track("custom", "Favorites-filter", {});
            }
            
            // Normalize filter_type to match expected format (e.g., "genetic" -> "strain")
            let filterType = keyWord;
            if (keyWord === "genetic") {
                filterType = "strain";
            } else if (keyWord === "type") {
                filterType = "product_type";
            } else if (keyWord === "Delivery Type") {
                filterType = "delivery_type";
            }
            
            // Normalize filter_value for price/thc/cbd ranges
            let filterValue = item.value;
            if (["thc", "cbd", "price"].includes(keyWord)) {
                filterValue = item.value.replace("gte", "min_").replace("lte", "max_");
            }
            
            MainTracker.track("custom", "filter_selected", {
                user_id: userId,
                filter_type: filterType,
                filter_value: filterValue
            });
        }
        
        // Keep existing tracking events for backward compatibility
        if (["effects", "genetic", "medical_effects"].includes(keyWord)) {
            MainTracker.track("custom", `${keyWord}-${item.value} Filter`);
        }

        else if (["thc", "cbd", "price"].includes(keyWord)) {
            const filterName = item.value.replace("gte", "min_").replace("lte", "max_");
            MainTracker.track("custom", `${keyWord}-${filterName} Filter`);
        }

        else if (keyWord === "Delivery Type") {
            const words = item.value.split(' ');
            const filterName = words[0]
            MainTracker.track("custom", `${keyWord}-${filterName} Filter`);
        }
    }

    return (
        <div
            className="
                select-none
                px-4
                "
            style={{ ...(!isLastChild && { borderBottom: "1px solid #DBE1EB" }) }}
        >
            {{
                favourite: (
                    <FavouriteFilter
                        filterOptions={filterOptions}
                        handleChooseFilter={handleChooseFilter}
                    />
                ),
                genetic: (
                    <CannabisGeneticFilter
                        filterOptions={filterOptions}
                        handleChooseFilter={handleChooseFilter}
                    />
                ),
                effects: (
                    <CannabisEffectsFilter
                        filterOptions={filterOptions}
                        handleChooseFilter={handleChooseFilter}
                    />
                ),
                type: (
                    <CannabisProductTypeFilter
                        filterOptions={filterOptions}
                        handleChooseFilter={handleChooseFilter}
                    />
                ),
                medical_effects: (
                    <MedicalEffectsFilter
                        filterOptions={filterOptions}
                        handleChooseFilter={handleChooseFilter}
                    />
                ),
                price: (
                    <MultiChoiceFilters
                        keyword={keyWord}
                        filterOptions={filterOptions}
                        handleChooseFilter={handleChooseFilter}
                        orientation="horizontal"
                    />
                ),
            }[keyWord] || (
                    // thc, cbd, Delivery-Type
                    <MultiChoiceFilters
                        keyword={keyWord}
                        filterOptions={filterOptions}
                        handleChooseFilter={handleChooseFilter}
                    />
                )}
        </div>
    )
}

